const serviceWorldStyle = {
  contentContainer: {
    padding: "25px",
    maxWidth: "500px",
    margin: "0 auto",
  },
};

export default serviceWorldStyle;
